function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2 64.7C57.8414 64.7 68.9 53.6414 68.9 40C68.9 26.3586 57.8414 15.3 44.2 15.3C30.5586 15.3 19.5 26.3586 19.5 40C19.5 53.6414 30.5586 64.7 44.2 64.7Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8 50.2C34.8 48.8 35.8 47.8 37.3 47.8H51.4001C52.8001 47.8 53.9001 48.8 53.9001 50.2C53.9001 51.6 52.9001 52.6 51.4001 52.6H37.3C35.8 52.6 34.8 51.6 34.8 50.2Z",
  fill: "#9B51E0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M44 45.9C45.3255 45.9 46.4 44.8255 46.4 43.5C46.4 42.1745 45.3255 41.1 44 41.1C42.6745 41.1 41.6 42.1745 41.6 43.5C41.6 44.8255 42.6745 45.9 44 45.9Z",
  fill: "#0BCEC9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.2 41.9L46.3 27.8C45.9 26.9 45.1 26.4 44.2 26.4H44.1H44C43.2 26.4 42.4 26.9 41.9 27.8L35 41.9C34.4 43.2 34.8 44.6 36 45.2C37.2 45.8 38.6 45.3 39.2 44.1L44 34.2L48.8 44.1C49.4 45.4 50.8 45.9 52 45.2C53.4 44.6 53.8 43.2 53.2 41.9Z",
  fill: "#9B51E0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M100 21.8C102.2 22.7 103.3 24 103.3 25.9C103.3 26.8 103 27.5 102.5 28.1C101.9 28.7 101.2 29 100.4 29C99.9 29 98.9 28.7 97.5 28.1C96 27.6 94.6 27.3 93.1 27.3C90.3 27.3 88.1 28.3 86.5 30.4C84.9 32.4 84.1 35 84.1 38.1C84.1 41.1 84.9 43.5 86.5 45.5C88.1 47.5 90.3 48.5 93.1 48.5C94.4 48.5 95.9 48.2 97.8 47.5C99.6 46.8 100.6 46.5 100.6 46.5C101.6 46.5 102.4 46.9 102.9 47.6C103.4 48.3 103.7 49 103.7 49.7C103.7 51.7 102.6 53.2 100.2 54C97.9 54.9 95.5 55.3 93 55.3C88.2 55.3 84.3 53.6 81.3 50.3C78.2 47 76.7 42.9 76.7 37.9C76.7 32.9 78.2 28.8 81.2 25.4C84.2 22.1 88.2 20.4 93 20.4C95.5 20.6 97.8 21 100 21.8Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M106.9 24.6C106.9 23.4 107.2 22.5 107.9 21.9C108.5 21.3 109.4 21 110.5 21C111.5 21 112.4 21.3 113.1 21.9C113.8 22.5 114.1 23.5 114.1 24.6V41.1C114.1 43.3 114.8 45.2 116.1 46.7C117.5 48.2 119.2 48.9 121.5 48.9C123.6 48.9 125.3 48.1 126.7 46.6C128.1 45.1 128.7 43.2 128.7 41.1V24.6C128.7 23.4 129 22.5 129.7 21.9C130.3 21.3 131.2 21 132.3 21C133.3 21 134.2 21.3 134.9 21.9C135.6 22.5 135.9 23.5 135.9 24.6V41.5C135.9 45.4 134.5 48.7 131.7 51.4C128.9 54.1 125.5 55.4 121.6 55.4C117.6 55.4 114.1 54.1 111.3 51.4C108.5 48.7 107.1 45.4 107.1 41.4V24.6H106.9Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M139.8 24.8C139.8 23.6 140.1 22.7 140.7 22.1C141.3 21.5 142.2 21.2 143.4 21.2H151.8C155.5 21.2 158.5 22.1 160.5 23.8C162.5 25.6 163.6 28.3 163.6 31.9C163.6 34.4 162.8 36.4 161.2 37.9C159.5 39.5 157.5 40.4 154.9 40.8L162.9 49.4C163.2 49.7 163.5 50.1 163.6 50.4C163.7 50.7 163.8 51.1 163.8 51.4C163.8 52.3 163.5 53.2 162.8 53.9C162.1 54.7 161.2 55 160.2 55C159.7 55 159.2 54.9 158.7 54.7C158.2 54.5 157.8 54.2 157.4 53.8L147 41.2L146.9 51.5C146.9 52.7 146.6 53.6 146 54.2C145.3 54.9 144.5 55.2 143.4 55.2C142.4 55.2 141.5 54.9 140.8 54.3C140.1 53.7 139.8 52.7 139.8 51.6V24.8ZM146.9 36.1H151.8C153.1 36.1 154.2 35.7 155 35C155.8 34.3 156.2 33.2 156.2 31.9C156.2 30.6 155.8 29.6 155 28.8C154.2 28.1 153.1 27.7 151.8 27.7H146.9V36.1Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M194 50C194.2 50.6 194.3 51.1 194.3 51.8C194.3 52.8 193.9 53.6 193.2 54.3C192.5 54.9 191.6 55.2 190.6 55.2C189.8 55.2 189.2 55 188.7 54.6C188.2 54.2 187.8 53.6 187.4 52.9L180 33.1L172.7 52.8C172.4 53.5 171.9 54.1 171.4 54.5C170.9 54.9 170.3 55.1 169.5 55.1C168.6 55.1 167.7 54.8 166.9 54.2C166.2 53.5 165.8 52.7 165.8 51.7C165.8 51.1 165.9 50.5 166.1 49.9L176.5 23.5C176.9 22.6 177.3 21.9 177.8 21.5C178.3 21 179 20.8 180 20.8C180.9 20.8 181.7 21 182.2 21.6C182.7 22.1 183.2 22.7 183.5 23.6L194 50Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M198.4 27.7H193.2C192.1 27.7 191.3 27.4 190.8 26.8C190.3 26.2 190 25.4 190 24.5C190 23.6 190.3 22.8 190.9 22.2C191.5 21.6 192.2 21.3 193.2 21.3H210.7C211.7 21.3 212.5 21.6 213.1 22.2C213.7 22.9 214 23.6 214 24.5C214 25.4 213.7 26.2 213.2 26.8C212.6 27.5 211.8 27.8 210.8 27.8H205.6V51.6C205.6 52.8 205.3 53.7 204.7 54.3C204 55 203.2 55.3 202 55.3C201 55.3 200.1 55 199.4 54.4C198.7 53.8 198.4 52.8 198.4 51.7V27.7Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M217.8 25.5C220.8 22.2 224.8 20.5 229.6 20.5C234.3 20.5 238.2 22.2 241.2 25.6C244.3 29 245.8 33.1 245.8 38C245.8 43 244.3 47.1 241.3 50.5C238.3 53.8 234.3 55.5 229.6 55.5C224.8 55.5 220.9 53.8 217.9 50.5C214.8 47.2 213.3 43.1 213.3 38.1C213.3 33.1 214.8 28.9 217.8 25.5ZM236.2 30.3C234.6 28.2 232.4 27.1 229.6 27.1C226.8 27.1 224.6 28.1 223 30.2C221.4 32.3 220.7 34.9 220.7 38C220.7 41.1 221.5 43.7 223 45.8C224.6 47.9 226.7 48.9 229.6 48.9C232.4 48.9 234.6 47.9 236.2 45.7C237.8 43.6 238.5 41.1 238.5 38C238.5 35 237.7 32.4 236.2 30.3Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M248.9 24.8C248.9 23.6 249.2 22.7 249.8 22.1C250.4 21.5 251.3 21.2 252.5 21.2H260.9C264.6 21.2 267.6 22.1 269.6 23.8C271.6 25.6 272.7 28.3 272.7 31.9C272.7 34.4 271.9 36.4 270.3 37.9C268.6 39.5 266.6 40.4 264 40.8L272 49.4C272.3 49.7 272.6 50.1 272.7 50.4C272.8 50.7 272.9 51.1 272.9 51.4C272.9 52.3 272.6 53.2 271.9 53.9C271.2 54.7 270.3 55 269.3 55C268.8 55 268.3 54.9 267.8 54.7C267.3 54.5 266.9 54.2 266.5 53.8L255.9 41.1L256 51.4C256 52.6 255.7 53.5 255.1 54.1C254.4 54.8 253.6 55.1 252.5 55.1C251.5 55.1 250.6 54.8 249.9 54.2C249.2 53.6 248.9 52.6 248.9 51.5V24.8ZM256 36.1H260.9C262.2 36.1 263.3 35.7 264.1 35C264.9 34.3 265.3 33.2 265.3 31.9C265.3 30.6 264.9 29.6 264.1 28.8C263.3 28.1 262.2 27.7 260.9 27.7H256V36.1Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M224.9 60.3C225.618 60.3 226.2 59.718 226.2 59C226.2 58.282 225.618 57.7 224.9 57.7C224.182 57.7 223.6 58.282 223.6 59C223.6 59.718 224.182 60.3 224.9 60.3Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M228.7 68.3C227.9 68.3 227.4 67.7 227.4 66.9V59C227.4 58.2 228 57.6 228.7 57.6C229.5 57.6 230 58.2 230 59V66.9C230.1 67.7 229.5 68.3 228.7 68.3Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M252.1 68.3C251.3 68.3 250.8 67.7 250.8 66.9V59C250.8 58.2 251.4 57.6 252.1 57.6C252.9 57.6 253.4 58.2 253.4 59V66.9C253.4 67.7 252.9 68.3 252.1 68.3Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M266.4 68.3C265.6 68.3 265.1 67.7 265.1 66.9V59C265.1 58.2 265.7 57.6 266.4 57.6C267.2 57.6 267.7 58.2 267.7 59V66.9C267.8 67.7 267.2 68.3 266.4 68.3Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M221.5 57.7C221.3 57.7 218 57.7 217.9 57.7C217.2 57.7 216.6 58.3 216.6 59C216.6 59.7 217.2 60.3 217.9 60.3H220.2V67C220.2 67.5 220.4 67.9 220.8 68.2C221 68.3 221.3 68.4 221.6 68.4C221.9 68.4 222.2 68.3 222.4 68.2C222.8 68 223 67.5 223 67V59C222.8 58.2 222.2 57.7 221.5 57.7Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M202.5 68.2C203.218 68.2 203.8 67.618 203.8 66.9C203.8 66.182 203.218 65.6 202.5 65.6C201.782 65.6 201.2 66.182 201.2 66.9C201.2 67.618 201.782 68.2 202.5 68.2Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M271.7 57.6H266.4V60.3H271.7C272.5 60.3 273.1 59.7 273.1 59C273.1 58.2 272.5 57.6 271.7 57.6Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M271.7 65.6H266.4V68.3H271.7C272.5 68.3 273.1 67.7 273.1 67C273.1 66.2 272.5 65.6 271.7 65.6Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M270.5 64.3C271.218 64.3 271.8 63.718 271.8 63C271.8 62.282 271.218 61.7 270.5 61.7C269.782 61.7 269.2 62.282 269.2 63C269.2 63.718 269.782 64.3 270.5 64.3Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M262.4 64.8C263.5 64.1 264.3 62.9 264.3 61.6C264.3 59.3 262.5 57.6 260.1 57.6H256.7H256.1C255.3 57.6 254.8 58.2 254.8 59V66.9C254.8 67.7 255.4 68.3 256.1 68.3C256.9 68.3 257.4 67.7 257.4 66.9V60.3H260.2C261 60.3 261.6 60.9 261.6 61.6C261.6 62.9 260.5 62.9 259.9 62.9C259.6 62.9 259.3 63 259 63.3C258.5 63.9 258.5 64.7 259.1 65.2L259.4 65.5L261.6 67.7C262.2 68.3 263 68.3 263.5 67.8C264.1 67.3 264.1 66.5 263.5 65.9L262.4 64.8Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M207.5 66.3L203.6 58.4C203.4 57.9 202.9 57.6 202.4 57.6H202.3H202.2C201.7 57.6 201.3 57.9 201 58.4L197.1 66.3C196.7 67 197 67.8 197.7 68.1C198.4 68.4 199.2 68.2 199.5 67.5L202.2 62L204.9 67.5C205.3 68.2 206 68.5 206.7 68.1C207.6 67.8 207.8 67.1 207.5 66.3Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M216.1 66.6C216.1 65.9 215.5 65.4 214.8 65.5C214.7 65.5 214.6 65.5 214.5 65.6C214.1 65.8 213.6 66 213.2 66C211.6 66.1 210.1 64.9 210 63.3C209.9 61.7 211.1 60.2 212.7 60.1C213.2 60.1 213.8 60.1 214.2 60.3C214.4 60.4 214.5 60.4 214.7 60.4C215.4 60.3 215.9 59.8 215.8 59.1C215.8 58.6 215.5 58.3 215.1 58.1C214.3 57.7 213.3 57.5 212.4 57.6C209.4 57.9 207.2 60.5 207.4 63.5C207.7 66.5 210.3 68.7 213.3 68.5C214 68.4 214.7 68.2 215.3 67.9C215.8 67.7 216.1 67.2 216.1 66.6Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M244.8 68.2C245.518 68.2 246.1 67.618 246.1 66.9C246.1 66.182 245.518 65.6 244.8 65.6C244.082 65.6 243.5 66.182 243.5 66.9C243.5 67.618 244.082 68.2 244.8 68.2Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M249.7 66.3L245.8 58.4C245.6 57.9 245.1 57.6 244.6 57.6H244.5H244.4C243.9 57.6 243.5 57.9 243.2 58.4L239.3 66.3C238.9 67 239.2 67.8 239.9 68.1C240.6 68.4 241.4 68.2 241.7 67.5L244.4 62L247.1 67.5C247.5 68.2 248.2 68.5 248.9 68.1C249.8 67.8 250.1 67 249.7 66.3Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M231.1 59.6L235 67.5C235.2 68 235.7 68.3 236.2 68.3H236.3H236.4C236.9 68.3 237.3 68 237.6 67.5L241.5 59.6C241.9 58.9 241.6 58.1 240.9 57.8C240.2 57.5 239.4 57.7 239.1 58.4L236.4 63.9L233.7 58.4C233.3 57.7 232.6 57.4 231.9 57.8C231 58.1 230.7 58.9 231.1 59.6Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M191.3 58.4C191.3 58.3 191.3 58.1 191.4 58.1C191.5 58 191.6 58 191.7 58H192.9C193.2 58 193.5 58.1 193.7 58.3C193.9 58.5 194 58.7 194 59.1C194 59.5 193.8 59.8 193.4 60C193.7 60 193.9 60.2 194.1 60.4C194.3 60.6 194.4 60.8 194.4 61.1C194.4 61.5 194.3 61.8 194 62.1C193.7 62.3 193.4 62.4 193 62.4H191.8C191.7 62.4 191.5 62.4 191.5 62.3C191.4 62.2 191.4 62.1 191.4 62V58.4H191.3ZM192.2 59.7H192.7C192.8 59.7 193 59.7 193.1 59.6C193.2 59.5 193.2 59.4 193.2 59.3C193.2 59.2 193.2 59.1 193.1 59C193 58.9 192.9 58.9 192.8 58.9H192.3V59.7H192.2ZM192.2 61.5H192.9C193.1 61.5 193.2 61.5 193.3 61.4C193.4 61.3 193.5 61.2 193.5 61C193.5 60.9 193.4 60.7 193.3 60.7C193.2 60.6 193 60.6 192.8 60.6H192.2V61.5Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M195.6 60.3L194.5 58.7C194.4 58.6 194.4 58.5 194.4 58.4C194.4 58.3 194.4 58.2 194.5 58.1C194.6 58 194.7 58 194.8 58C195 58 195.1 58.1 195.2 58.2L196.1 59.5L197 58.2C197.1 58.1 197.2 58 197.4 58C197.5 58 197.6 58 197.7 58.1C197.8 58.2 197.8 58.3 197.8 58.4C197.8 58.5 197.8 58.6 197.7 58.7L196.6 60.3V61.9C196.6 62 196.6 62.1 196.5 62.2C196.4 62.3 196.3 62.3 196.2 62.3C196 62.3 195.9 62.3 195.9 62.2C195.9 62.1 195.8 62 195.8 61.9V60.3H195.6Z",
  fill: "white"
});

function SvgCuratorlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 85,
    viewBox: "0 0 293 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratorlogo);
export default __webpack_public_path__ + "static/media/curatorlogo.d1428a18.svg";
export { ForwardRef as ReactComponent };